/** The theme's color mode CSS class */
export enum ColorModeClass {
    Dark = 'dark-mode',
    Light = 'light-mode',
}
